import React, { Component } from 'react';
import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SyncMessage from "../../components/SyncMessage";

class BidderSources extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            configToUpdate: null,
            sortParam: null,
            sortOrder: 1,
            configs: [],
            partners: [],
            syncData: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        this.loadConfigs();
        this.loadPartners();
    }

    componentWillUpdate(nextProps, nextState) {
        const { configs, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(configs, sortParam, sortOrder);

            this.setState({ configs });
        }
    }

    sortReport(configs, sortParam, sortOrder) {
        configs.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadConfigs() {
        this.setState({ isLoading: true });

        API.PushapiConfig.get().then(configs => this.setState({ configs, isLoading: false }));
    }

    loadPartners() {
        API.PushapiPartners.get().then(partners => {
            partners = partners.reduce((obj, { id, name }) => {
                obj[id] = name;

                return obj;
            }, {})

            this.setState({ partners });
        });
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, configToUpdate: null });
    }

    handleFormSubmit(config) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            configToUpdate: null
        });

        if(config.update) {
            const { affid } = config;

            delete config.id;

            API.PushapiConfig.update(affid, config).then(() => this.loadConfigs());
        }
        else API.PushapiConfig.save(config).then(() => this.loadConfigs());
    }

    handleUpdateBtnClick(config) {
        this.setState({ isShowForm: true,  configToUpdate: config });
    }

    handleRemoveBtnClick(affid) {
        this.setState({ isLoading: true });

        API.PushapiConfig.remove(affid).then(() => this.loadConfigs());
    }

    handleSync() {
        this.setState({ isLoading: true });

        Promise.all([
            API.Sync(['pushapi-eu', 'pushapi-eu-clk', 'pushapi-us', 'pushapi-us-clk'], 'affidConfig', 8081),
            API.Sync(['pushapi-v2-EU'], 'feeds', 8084)
        ]).then(([ res, res2 ]) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                config={this.state.configToUpdate}
                partners={this.state.partners}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Pushapi Config"/>
                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />

                {this.getForm()}

                <Table configs={this.state.configs} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick} onSort={this.handleSort} partners={this.state.partners}/>
            </Container>
        );
    }
}

export default BidderSources;


// WEBPACK FOOTER //
// ./src/scenes/PushapiConfig/index.js